"use strict";

var _classCallCheck = require("/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/createClass.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var i = /*#__PURE__*/function () {
  function i(t) {
    _classCallCheck(this, i);
    this.source = t, this.lastPosition = {
      line: 1,
      column: 1
    }, this.lastIndex = 0;
  }
  _createClass(i, [{
    key: "getPosition",
    value: function getPosition(t) {
      if (t < this.lastIndex) throw new Error("Source indices must be monotonic");
      for (; this.lastIndex < t;) {
        this.source.charCodeAt(this.lastIndex) === 10 ? (this.lastPosition.line++, this.lastPosition.column = 1) : this.lastPosition.column++, this.lastIndex++;
      }
      return {
        line: this.lastPosition.line,
        column: this.lastPosition.column
      };
    }
  }]);
  return i;
}();
exports.a = i;